<template>
  <div v-if="resolvedBlock" :class="wrapperClasses">
    <div :class="compact ? 'preview-scale-inner' : null">
      <DynamicBlock :block="resolvedBlock" />
    </div>
  </div>
  <div v-else class="preview-placeholder preview-placeholder-error">
    <div class="preview-placeholder-content">
      <div class="preview-placeholder-icon">
        <svg
          class="h-6 w-6 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <div class="text-xs font-medium text-gray-400">
        Nie znaleziono bloku
      </div>
    </div>
  </div>
</template>

<script>
import DynamicBlock from '@/Shared/DynamicBlock.vue';

export default {
  name: 'BlockPreview',
  components: { DynamicBlock },
  props: {
    block: {
      type: Object,
      required: false,
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    // Page configurator: cap preview height. Blocks list uses compact without this.
    constrained: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    resolvedBlock() {
      if (!this.block) return null;
      return {
        ...this.block,
        preview_mode: this.compact ? true : Boolean(this.block.preview_mode),
      };
    },
    wrapperClasses() {
      return [
        'preview-wrapper',
        this.compact ? 'preview-wrapper--compact' : null,
        this.constrained ? 'preview-wrapper--constrained' : null,
      ];
    },
  },
};
</script>

<style scoped>
.preview-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 0.5rem;
}

.preview-wrapper--compact {
  border: 1px solid rgb(229 231 235);
  background: rgb(249 250 251);
  overflow-x: auto;
  pointer-events: none;
  user-select: none;
}

.preview-wrapper--constrained {
  max-height: 202px;
  overflow: hidden;
}

.preview-scale-inner {
  --preview-scale: 0.6;
  zoom: var(--preview-scale);
  pointer-events: none;
  user-select: none;
}

@supports not (zoom: 1) {
  .preview-scale-inner {
    zoom: unset;
    transform: scale(var(--preview-scale));
    transform-origin: top left;
    width: calc(100% / var(--preview-scale));
  }
}

.preview-placeholder {
  position: relative;
  overflow: hidden;
  border-radius: 0.5rem;
  border: 2px dashed rgb(229 231 235);
  background: linear-gradient(to bottom right, rgb(249 250 251), rgba(243, 244, 246, 0.5));
  padding: 1.5rem;
}

.preview-placeholder-error {
  border-color: rgb(229 231 235);
  background: rgb(249 250 251);
}

.preview-placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.preview-placeholder-icon {
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-wrapper :deep(*) {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

/* Rich-text images use rt-img-*; block template photos use block-photo — both
   keep their own sizing. Generic reset applies only to other imgs. */
.preview-wrapper :deep(img:not([class*="rt-img-"]):not(.block-photo)) {
  max-width: inherit;
  width: inherit;
  border-radius: 0.25rem;
  object-fit: contain;
}

.preview-wrapper :deep(> *) {
  width: 100%;
}
</style>
